/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
export enum Progress {
    // 上传检查项组件包
    checkFileSelected = 'checkFileSelected',
    checkFileUploading = 'checkFileUploading',
    checkFileUploadSuc = 'checkFileUploadSuc',
    checkFileUploadFailed = 'checkFileUploadFailed',
    // 检查项组件包更新
    checkFileUpgrading = 'checkFileDistributing',
    checkFileUpgradeSuc = 'checkFileUpgradeSuc',
    checkFileUpgradeFailed = 'checkFileUpgradeFailed',
    // 上传升级包
    packageUploading = 'packageUploading',
    packageUploadSuc = 'packageUploadingSuc',
    packageUploadFail = 'packageUploadFail',
    // 上传补丁包
    hotpatchUploading = 'hotpatchUploading',
    hotpatchUploadSuc = 'hotpatchUploadingSuc',
    hotpatchUploadFail = 'hotpatchUploadFail',
    // 分发升级包
    packageDistributWaiting = 'packageDistribuWaiting',
    packageDistributing = 'packageDistributing',
    packageDistributeSuc = 'packageDistributeingSuc',
    packageDistributeFail = 'packageDistributeFail',
    // 升级前评估
    readyEvaluate = 'readyEvaluate',
    evaluating = 'evaluating',
    evaluateFailed = 'evaluateFailed',
    evaluateSuc = 'evaluateSuc',
    // 升级前检查
    readyPrecheck = 'readyPrecheck',
    prechecking = 'prechecking',
    precheckFailed = 'precheckFailed',
    precheckSuc = 'precheckSuc',
    // 执行升级失败
    executeUpgradeFailed = 'executeUpgradeFailed',
    // 升级中
    readyUpgrade = 'readyUpgrade',
    upgrading = 'upgrading',
    upgradeFailed = 'upgradeFailed',
    upgradePause = 'upgradePause',
    upgradeSuc = 'upgradeSuc',
    // 升级后检查
    readyVerify = 'readyVerify',
    verifying = 'verifying',
    verifyFailed = 'verifyFailed',
    verifySuc = 'verifySuc',
    // 回滚
    readyRollback = 'readyRollback',
    rollBacking = 'rollBacking',
    rollBackFailed = 'rollBackFailed',
    rollBackSuc = 'rollBackSuc',
    rollBackPause = 'rollBackPause'
}

export enum CheckStatusE {
    Init = 0,
    Checking = 1,
    Done = 2,
    Failed = 3
}

// 升级状态
export const UPD_STATUS_E = {
    UPD_READY: '0',
    UPD_BEFORECHEKING: '1',
    UPD_BEFORECHEK_SUCCESS: '2',
    UPD_BEFORECHEK_FAIL: '3',
    UPD_DLDING: '4',
    UPD_DLD_SUCCESS: '5',
    UPD_DLD_FAIL: '6',
    UPD_ACTIVING: '7',
    UPD_ACTIVE_SUCCESS: '8',
    UPD_ACTIVE_FAIL: '9',
    UPD_UPDING: '10',
    UPD_UPD_SUCCESS: '11',
    UPD_UPD_FAIL: '12',
    UPD_ROLLBACKING: '13',
    UPD_ROLLBACK_SUCCESS: '14',
    UPD_ROLLBACK_FAIL: '15',
    UPD_AFTCHECKING: '16',
    UPD_AFTCHECK_SUCCESS: '17',
    UPD_AFTCHECK_FAIL: '18',
    UPD_FINISHING: '19',
};

// 升级查询类型
export const UPGRADE_QUERY_TYPE = {
    // 分发包
    Upload: '0',
    // 系统升级
    System: '1',
    // 热补丁
    HotPatch: '5',
};

export enum UPLOAD_STATUS {
    // 分发
    distributing = 'distributing',
    // 上传中
    ing = 'ing',
    err = 'err',
    suc = 'suc'
}

/**
 * 升级方式
 */
export enum UpgradeModeE {
    System = 'system',
    HotPatch = 'hotPatch',
    Ota = 'ota'
}

/**
 * 升级类型
 *
 * 0 开始
 *
 * 1 升级中，预留
 *
 * 2 重试
 *
 * 3 回滚
 *
 * 4 终止
 *
 * 5 修复
 */
export enum UpgradeTypeE {
    Start = 0,
    Upgrade = 1,
    Retry = 2,
    Rollback = 3,
    End = 4,
    Fix = 5
}

/**
 * 检查/升级/回滚详情状态
 */
export enum CheckResult {
    Uncheck = 0,
    Checking = 1,
    Suc = 2,
    Fail = 3,
    Error = 4,
    Ignore = 5
}

export enum CmoUpdSysModeE {
    FastUpgrade = 2,
    HotpatchInstall = 5,
    HotpatchDelete = 6,
    HotpatchRollback = 7,
    FastUpgradeWithHotpatch = 12,
    OtaUpgrade = 14,
    /**
     * 热补丁，自定义枚举
     */
    Hotpatch = 101
}

export enum CmoUpdSysStepTaskStatusE {
    Initialization = 0,
    PreChecking = 1,
    PrecheckSuc = 2,
    PrecheckFail = 3,
    Upgrading = 10,
    UpgradeSuc = 11,
    UpgradeFail = 12,
    Rollbacking = 13,
    RollbackSuc = 14,
    RollbackFail = 15,
    UpgradePause = 20,
    RollbackPause = 21
}

export enum PackageTypeE {
    SystemSoftware = '1',
    Hotpatch = '3',
    HotpatchDuringUpgrade = '7'
}

export enum CmoQueryTypeE {
    /**
     * 分发包
     */
    Distribute = 0,
    /**
     * 快速升级
     */
    SystemUpgrade = 1,
    /**
     * 热补丁
     */
    Hotpatch = 5,
    /**
     * OTA升级
     */
    OtaUpgrade = 9
}

/**
 * 查询来源。
 *
 * 查升级状态的时候区分是哪端在获取
 */
export enum CmoQueryFrom {
    /**
     * Device Manager
     */
    DM = 1
}

export enum CmoDetailAtomState {
    init = '0',
    executing = '1',
    success = '2',
    fail = '3',
    error = '4',
    skip = '5',
    pause = '6'
}

export interface StatusCount {
    all?: number;
    suc?: number;
    fail?: number;
    ignore?: number;
}

export interface PreCheckParams {
    checkType?: string;
    checkCMD?: 0 | 1;
    skipItem?: string;
    extend_param?: { targetVersion: string };
}

export interface UpgradeDetail {
    /**
     * 错误信息
     */
    CMO_DETAIL_ATOM_RECORD?: string;
    /**
     * 状态
     */
    CMO_DETAIL_ATOM_STATE?: CmoDetailAtomState;
    /**
     * 节点ID
     */
    CMO_DETAIL_NODE_ID?: string;
    /**
     * 步骤名
     */
    CMO_STEP_NAME?: string;
}

export const DoneStatus = [CheckResult.Error, CheckResult.Fail, CheckResult.Suc, CheckResult.Ignore];

export const CheckFileProcesses = [
    Progress.checkFileSelected,
    Progress.checkFileUploading,
    Progress.checkFileUploadSuc,
    Progress.checkFileUploadFailed,
];

export const EvaluateProcesses = [
    Progress.evaluating,
    Progress.evaluateSuc,
    Progress.evaluateFailed,
    Progress.checkFileUpgrading,
    Progress.checkFileUpgradeSuc,
    Progress.checkFileUpgradeFailed,
];

export const PackageUploadProcesses = [
    Progress.packageUploading,
    Progress.packageUploadFail,
    Progress.packageUploadSuc,
];

export const HotpatchUploadProcesses = [
    Progress.hotpatchUploading,
    Progress.hotpatchUploadFail,
    Progress.hotpatchUploadSuc,
];

export const UpgradeProcesses = [...PackageUploadProcesses, ...HotpatchUploadProcesses];

export interface CheckDetail {
    /**
     * 自定义的ID
     */
    ID?: string;
    checkItem?: string;
    checkResult?: CheckResult;
    checkTime?: string;
    /**
     * 检查标准
     */
    criterion?: string;
    curCheckType?: string;
    helphref?: string;
    method?: string;
    name?: string;
    returnValue?: number;
    suggestion?: string;
    /**
     * 是否支持跳过
     */
    isSupportSkip?: boolean;
    /**
     * 是否是用户本次忽略的
     */
    skipByUser?: boolean;
    nodeInfoArr?: NodeInfoArr[];
    nodeInfo?: Record<string, unknown>;
    /**
     * UTC时间戳
     */
    utcTimeStamp?: number;
}

/**
 * 节点信息数组
 */
export interface NodeInfoArr {
    node: string;
    info: string;
}

/**
 * 升级方式
 */
export enum UpgradeMethodE {
    // OTA升级
    OtaUpgrade = 1,
    // 其他
    Others = 2
}

/**
 * 当前升级步骤
 */
export enum CurrentStageE {
    // 升级前评估
    Evaluation = 0,
    // 下载包
    DownloadPackage = 1,
    // 分发包
    DistributionPackage = 2,
    // 升级前检查
    PreCheck = 3,
    // 系统升级
    SystemUpgrade = 4,
    // 补丁升级
    HotpatchUpgrade = 5,
    // 升级后检查
    AfterCheck = 6
}
